import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "BlueOrbit Technologies - Innovative Mobile App Solutions", 
  description = "BlueOrbit Technologies creates innovative mobile apps like Status Saver for WhatsApp.", 
  keywords = "WhatsApp status saver, status downloader, BlueOrbit Technologies, mobile apps, status manager, WhatsApp tools",
  image = "/CompanyLogo.png",
  url = window.location.href,
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Basic metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="BlueOrbit Technologies" />
      
      {/* Open Graph metadata */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:site_name" content="BlueOrbit Technologies" />
      
      {/* Twitter Card metadata */}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEO;